export default {"src":"/_next/static/media/top-curve-grey-right.dd5beb1e.svg","height":251,"width":1440,"blurWidth":0,"blurHeight":0};